import styled, { css } from 'styled-components';
import _Section from '../Section';

export const Section = styled(_Section)(
  ({ theme }) => css`
    padding-top: ${theme.sz.s10};
    padding-bottom: ${theme.sz.s10};
    background-color: ${theme.co.neutral0};
  `,
);

export const SectionContent = styled(_Section.Content)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;
    gap: ${theme.sz.s6};

    @media (min-width: 1152px) {
      flex-direction: row;
    }
  `,
);
